import ApiService from "../../../services/api";
import moment from "moment";
import helpers from "../../../shared/fleetbox-helpers";
import property from '../chartProperties';

export default {
	data: function() {
		return {
			/* Drive/idle time */
			pdfOptions: {
				landscape: true,
				fileName: "Tempi_di_viaggio",
				title: "Tempi di viaggio"
			},
			driveIdleTimeModal: false,
			driveIdleTime: [
				{
					name: "Tempo in movimento",
					field: "drive",
					color: property.driveIdleTime.colorDrive,
					labels: {
						visible: false,
						template: this.getTimeFromString,
						background: "none",
						font: "10px montserrat-light"
					}
				},
				{
					name: "Tempo di inattività",
					field: "idle",
					color: property.driveIdleTime.colorIdle,
					labels: {
						visible: true,
						template: this.getStackTimeFromString,
						background: "none",
						font: "10px montserrat-light"
					}
				}
			],
			driveIdleTimeSeriesModal: [
				{
					name: "Tempo in movimento",
					field: "drive",
					color: property.driveIdleTime.colorDrive,
					labels: {
						visible: false,
						template: this.getTimeFromString,
						background: "none",
						font: "10px montserrat-light"
					}
				},
				{
					name: "Tempo di inattività",
					field: "idle",
					color: property.driveIdleTime.colorIdle,
					labels: {
						visible: true,
						template: this.getStackTimeFromString,
						background: "none",
						font: "10px montserrat-light"
					}
				}
			],
			yAxis: {
				labels: {}
			},
			legend: {
				position: "bottom",
				item: {
					visual: function(e) {
						var color = e.series.color; //e.options.markers.background;
						var labelColor = e.options.labels.color;
						var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
						var layout = new kendo.drawing.Layout(rect, {
							spacing: 5,
							alignItems: "center"
						});

						var marker = new kendo.drawing.Path({
							fill: {
								color: color
							},
							stroke: {
								color: color
							}
						})
							.moveTo(0, 0)
							.lineTo(0, 10)
							.lineTo(30, 10)
							.lineTo(30, 0)
							.close();

						var label = new kendo.drawing.Text(e.series.name, [0, 0], {
							fill: {
								color: labelColor
							},
							font: "13px 'Montserrat Light', montserrat-light !important"
						});

						var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
						var rectangle = new kendo.drawing.Rect(rectGeom, {
							fill: { color: "none" },
							stroke: { color: "none" }
						});

						layout.append(marker, label, rectangle);
						layout.reflow();

						return layout;
					}
				}
			},
			driveIdleTimeData: [],
			driveIdleTimeTooltip: {
				visible: true,
				template: this.getDriveIdleTooltip
			},
			driveIdleTimeCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				labels: {
					font: "10px montserrat-light",
					padding: {
						right: 10
					}
				}
			},
			driveIdleTimeValueAxis: {
				//max: 1000000,
				line: {
					visible: false
				},
				minorGridLines: {
					visible: false
				},
				labels: {
					content: this.getTimeFromString,
					visible: false,
					font: "10px montserrat-light"
				}
			},
			driveIdleTimeValueAxisModal: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "Ore",
						rotation: 0,
						font: "10px montserrat-light"
					},
					labels: {
						content: this.getTimeFromString,
						visible: true,
						font: "10px montserrat-light"
					}
				}
			],
			driveIdleTimeChartIndex: 0,
			driveIdleTimeModalIndex: 0,
			modalTitle: "Tempi movimento / inattività da",
			loading: true
			/* Drive/idle time */
		};
	},
	watch: {},
	created() {
		this.getTripsCounter();
	},
	methods: {
		getDriveIdleTooltip(e) {
			var timeFromSeconds = this.$options.filters.timeFromSecondsToString(e.value);
			return `${e.series.name} dal ${e.dataItem.from} al ${e.dataItem.to}: ${timeFromSeconds}`;
		},
		getTimeFromString(e) {
			return this.$options.filters.timeFromSecondsToString(e.value);
		},
		getTimeFromStringPdf(e) {
			var result = `${this.getStackTimeFromString(e)}\n . \n${this.getTimeFromString(e)}`;
			return result;
		},
		getStackTimeFromString(e) {
			return this.$options.filters.timeFromSecondsToString(e.stackValue);
		},
		driveIdleTimeClickHandler() {
			this.driveIdleTimeModal = true;
			$(".k-tooltip.k-chart-tooltip").remove();
			setTimeout(() => {
				this.driveIdleTimeModalIndex++;
			}, 200);
		},
		/* Trips Counter */
		getTripsCounter() {
			var self = this;
			ApiService.getTripsCounter().then(res => {
				self.getUserFriendlyTripsCounter(res);

				setTimeout(function() {
					self.loading = false;
				}, 500);
			});
		},

		getUserFriendlyTripsCounter(data) {
			var self = this;
			if (data && data.length > 0) {
				var maxDate = _.maxBy(data, function(o) {
					return moment(o.to);
				}).to;

				var minDate = _.minBy(data, function(o) {
					return moment(o.from);
				}).from;

				this.modalTitle = `Tempi movimento / inattività dal ${this.$options.filters.dateToString(moment(minDate))} al ${this.$options.filters.dateToString(moment(maxDate))} (settimanale)`;
				this.pdfOptions.title = `Tempi movimento / inattività dal ${this.$options.filters.dateToString(moment(minDate))} al ${this.$options.filters.dateToString(moment(maxDate))}`;
				this.pdfOptions.fileName = helpers.chartPdffileName(this, "Tempi_di_viaggio", minDate, maxDate);
				data.forEach(function(item) {
					self.driveIdleTimeCategoryAxis.categories.push(self.$options.filters.dateToString(item.from));

					var totalTime = item.drive_time + item.idle_time;

					self.driveIdleTimeData.push({
						from: self.$options.filters.dateToString(item.from),
						to: self.$options.filters.dateToString(item.to),
						drive: parseInt(item.values.drive_time),
						idle: parseInt(item.values.idle_time),
						valueTime: self.$options.filters.timeFromSecondsToString(item.drive_time),
						idleTime: self.$options.filters.timeFromSecondsToString(item.idle_time),
						totalTime: self.$options.filters.timeFromSecondsToString(totalTime),
						sumField: 0
					});
				});
			}
		},
		/* Trips Counter */

		//#region Utils
		exportAsPdf() {
			// var chart = this.$refs.chartDriveIdleTimeModal.kendoWidget();
			// chart.saveAsPDF();

			var container = $("<div />")
				.css({
					position: "absolute",
					top: 0,
					left: -1500,
					height: 600
				})
				.appendTo("body");

			function cleanup() {
				container.getKendoChart().destroy();
				container.remove();
			}

			this.createChart(container, {
				// Custom settings for export
				transitions: false,

				// Cleanup
				render: function(e) {
					e.sender.saveAsPDF();
					setTimeout(cleanup, 500);
				}
			});
		},

		createChart(container, exportOptions) {
			var self = this;

			var options = {
				pdf: self.pdfOptions,
				theme: "metro",
				title: {
					text: self.modalTitle.toUpperCase(),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					visible: true,
					position: "bottom",
					item: {
						visual: function(e) {
							var color = e.series.color; //e.options.markers.background;
							var labelColor = e.options.labels.color;
							var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var label = new kendo.drawing.Text(e.series.name, [0, 0], {
								fill: {
									color: labelColor
								},
								font: "13px 'Montserrat Light', montserrat-light"
							});

							layout.append(marker, label);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefaults: {
					type: "column",
					labels: {
						visible: true
					}
				},
				dataSource: {
					data: self.driveIdleTimeData
				},
				series: [
					{
						name: "TEMPO IN MOVIMENTO",
						field: "drive",
						color: property.driveIdleTime.colorDrive,
						labels: {
							visible: true,
							margin: -20,
							template: self.getTimeFromString,
							font: "13px montserrat-light"
						},
						stack: true
					},
					{
						name: "TEMPO DI INATTIVITA'",
						field: "idle",
						color: property.driveIdleTime.colorIdle,
						labels: {
							visible: true,
							margin: -20,
							template: self.getTimeFromString,
							font: "13px montserrat-light"
						},
						stack: true
					},
					{
						name: "",
						field: "sumField",
						color: "#fff",
						labels: {
							visible: false,
							template: self.getStackTimeFromString,
							font: "13px montserrat-light"
						},
						stack: true
					}
				],
				valueAxis: {
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "ORE",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						font: "13px montserrat-light"
					}
				},
				categoryAxis: {
					categories: self.driveIdleTimeCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light"
					}
				}
			};

			options = $.extend(true, options, exportOptions);
			container.kendoChart(options);
		},

		exportAsXlsx(type) {
			var self = this;
			ApiService.exportAnalyticsXlsx("timings", type).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Tempi movimento_inattività.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		}
		//#endregion
	}
};
